import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill", "height", "width"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M24.765 18.3191C30.0066 16.4208 36.0841 20.2458 36.0841 26.3233H33.5483C32.9108 26.3233 32.5991 27.0883 33.0525 27.5274L37.005 31.4799C37.2883 31.7633 37.7275 31.7633 38.0108 31.4799L41.9633 27.5274C42.4025 27.0883 42.0908 26.3233 41.4675 26.3233L38.9175 26.3233C38.9175 18.1633 30.7291 13.0208 23.6316 15.7266C22.725 16.0666 22.5125 17.2566 23.1925 17.9224L23.3058 18.0358C23.6883 18.4183 24.255 18.5033 24.765 18.3191Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M30.3892 34.3132C24.9492 36.2541 19.0842 32.2307 19.0842 26.3232H21.6201C22.2576 26.3232 22.5692 25.5582 22.1159 25.1191L18.1634 21.1524C17.8801 20.8691 17.4409 20.8691 17.1576 21.1524L13.2051 25.1049C12.7659 25.5582 13.0776 26.3232 13.7151 26.3232H16.2509C16.2509 34.4832 24.4392 39.6257 31.5367 36.9199C32.4292 36.5799 32.6417 35.3899 31.9617 34.7099L31.8626 34.6107C31.4801 34.2282 30.9134 34.1432 30.3892 34.3132Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 54 54",
    fill: _ctx.color,
    height: _ctx.size,
    width: _ctx.size,
    "aria-hidden": "true"
  }, _hoisted_4, 8, _hoisted_1))
}